import { useCallback } from "react";
import moment from 'moment';

export const InductionData = {
  firstRow:
    "Time to time the booklet will undergo revisions and therefore all employees may also refer to this section to be aware about new added provisions. The Booklet does not contain all the information that employee’s may require during progression in organization, but the objective of this manual is to give basic orientation about the organization and its basic code of conduct ",
  secondRow:
    "To be aware about organizational Policies & Circulars please refer the relevant section of SkyNet, it will address all your administrative queries pertaining to leaves, working hours, facilities etc",
  thirdRow:
    "To be aware about work practices of Organization, please gel up with people around, HR of location is always available for healthy interaction with you and address your rational curiosity about anything.",
  forthRow:
    "Site specific SOPs and procedural guidelines are also available at relevant departments of your site, you may approach your HOD for guidance on the same.",
};

export const EmployeeHRData = {
  firstRow:
    "Human resource policies are formal rules and procedures that dictate how certain matters should be addressed in the workplace, including employee rights and duties. Without HR policies, a chaotic work environment could result because there are no set rules to follow. Employees must play their part by complying with the human resource policies that relate to them ",
  secondRow:
    " HR policies at Ind-Swift Laboratories Ltd are designed to promote communication and understanding between various hierarchical layers of organization. Policies are designed in most scientific manner after carefully reviewing the internal and external environment of the organization. Objective of HR Policies at Ind-Swift Laboratories Ltd is to establish and maintain consistent practices at the workplace",
  thirdRow:
    "HR policies and procedures of ISLL act as tactical elements of our strategic plan. On periodic basis policies of the organization undergo detailed review by HR department to align the policy provisions with changes in internal and external environment of the organization",
  forthRow:
    "This section provides an open access of all HR Policies of the organization to all employees. Employees may use this medium to refer the policies as and when required in their day to day operations. The section will automatically be updated as and when any policy is changed so that employees are always available with recent set of guidelines.",
};

export const EmployeeCircularData = {
  firstRow:
    "Time to time various “Circulars” are being issued from the office of Top Management to bring clarity on various operational aspects",
  secondRow:
    " These circulars intend to notify important changes to all employees of the organization, at times circulars are bring clarity on expectations of deliverabilities. It is of critical importance that all employees take serious note of the circulars and comply with the guidelines mentioned in them",
  thirdRow:
    "Over a period some circulars loose attention of employees and therefore this section is focused on providing open and quick access to all circulars of critical importance ever issued from any forum of top management.",
  forthRow:
    "Employees are expected to refer these circulars whenever they come across any relevant situation at workplace",
  fifthRow:
    "New circulars being issued in future will automatically be updated on the platform.",
};
export const EmployeeknowledgeData = {
  firstRow:
    "Many innovations and initiatives keep going in the organization at any given point of time, but these interventions do not live to their actual potential until and unless they are properly shared and discussed among all intellectuals of the organization.",
  secondRow:
    "This generates the need to have a common “Knowledge Center” where all employees can share anything performed by them that has brought some tangible or intangible synergy to the organization. It can be a study, a kaizen, a model, a theory, an article, a blog or anything which employee feels is worthwhile to share with all provided that it should be an intellectual subject. ",
  thirdRow:
    "The achievements, exceptional performances, outstanding projects competed by any employee will also become part of Knowledge center so that everyone in organization can see, appreciate and learn from the efforts being done by their colleagues and friends.",
  forthRow:
    "Say for example engineering team of a “Unit” has performed some mechanical changes in plant due to which process efficiencies has improved at that site, it should be shared (through a work paper) with every one so that teams working at other site may also learn and apply the innovations to achieve the same results.",
  fifthRow:
    "Knowledge centers if utilized can act as brilliant source of knowledge exchange between employees",
  sixthRow:
    "To start with source, some survey reports being done by HR department are shared over the resource. These reports have acted as base for bringing changes in PMS of the organization. On the basis of the outcomes of these reports, organization decided to move towards a more scientific process of performance appraisal in organization. Similarly other employees, departments and teams are encouraged to send the stiff that can be shared here. Learning comes by sharing !",
};
export const EmployeeEngagementData = {
  firstRow:
    "Employee Engagement, Employee Welfare and Employee Empowerment (The 3 E’s) have remained to be 3 key priority areas for Ind-Swift’s performance culture since from our commencement.",
  secondRow:
    "Organization has been doing a lot on these 3 aspects with coordination and corporation from all our employees who are integral part of our common identity i.e. “Swift Family”.",
  thirdRow:
    "We are touching all areas of Human Development & Happiness in organization by means our “Swift Happiness Capitalization Module (S-HCM)”.",
  forthRow:
    "Swift-HCM as a module comprises of 4 branches, each of which contains further programs and interventions. These branches work with different focus on different attributes.",
};

export const EmployeeDrishtiData = {
  firstRow:
    "Drishti is not just a symbol of seeing things but it also an epitome of “Equally seeing things”. Drishti enables every living being on planet to see the colours of world equally without any discrimination.",
  secondRow:
    "On this principle of equality, Drishti Branch of “Swift SkyNet” works for area of Employee Welfare covering all employees of organization equally and it includes 3 programs.",
};
export const myClaimData = {
  firstRow:
    "Organization provides various benefits and reimbursements (against expenses) to employees through relevant HR policies. ",
  secondRow:
    "In this section of SkyNet, you can digitally file your claims or applications with HR that will be processed as per your entitlements. You can also keep a track of your applications digitally. Claims and applications are auto programed to get aligned with your remaining entitlements of ongoing FY.  If you are unable to file a claim then it means you may have exhausted your limits of you are not eligible for said claim/application.",
  thirdRow:
    "If you experience any difficulty in filling any claim or application, please reach to respective site HR or Corporate HR for your assistance.",
};
export const EmployeeIkigaiData = {
  firstRow:
    "Udeshya means “Finding Meaning and Purpose of Life”. Whatever we do in life, it is very important to see meaning in the same without which everything will simply be purposeless, same is true for work as well.",
  secondRow:
    "“Meaning of Actions” is most important force that keeps a person engaged with life, with work and with others as well. Based on this principle, the Udeshya branch of SkyNet works for area of Employee Empowerment that operates to empower employees by helping them finding meaning in their work and by helping them in giving channels of open communications.",
};
export const EmployeeDeepakData = {
  firstRow:
    "No matter how dark and intense the darkness is, just a single “Deepak” is enough to shunt that away. With this thought Deepak Branch of “SkyNet” works for area of Social Welfare",
  secondRow:
    "This branch provides opportunity to employees and organization for coming together and do something for society as a family.",
};
export const DrishtiRowFirst = {
  title: "SEA",
  content: [
    "Standing for Swift Employee Advantage. This Program focuses on formulating corporate tie ups with various service providers in external environment like Hospitals, Schools, Institutes, Hotels, restaurants etc to provide a discounted pricing exclusively and equally for all employees of Ind-Swift.",
    "Organization runs 15+ Corporate Tie Ups under SEA that provides substantial discounts to all employees of Ind-Swift for availing services from these terminals.",
  ],
};

export const DrishtiRowSecond = {
  title: "I-AWARE",
  content: [
    "This program focus on organizing financial learning camps, credit understanding camps, educations camps, NPS camps, Real-Estate camps etc for awareness and better understanding of employees towards investments/taxation etc.",
    "Objective is to enhance knowledge and awareness of employees for their financial & social wellbeing.",
  ],
};

export const DrishtiRowThird = {
  title: "SURAKSHA CHAKRA",
  content: [
    "This program works to provide our employees & their families sufficient insurances (like NPS, Supperannuation, GMC, GTI, SC, PHC, Medical Camps, Elephant Statutory Coverages etc) for coverages against unforeseen incidents. The program also focuses on organizing in-house medical check-up camps for employees at set periodicity",
  ],
};

export const DrishtiData = [DrishtiRowFirst, DrishtiRowSecond, DrishtiRowThird];

export const IkigaiData = [
  {
    title: "Performance Management Framework (PMS, PLI, DISHA, C-GSP)",
    content: [
      " A scientific, credible and transparent 360 Degree based PMS of organization which is linked with budgets, data and performance of department/individuals is working in organization for ensuring that proper feedback is provided to employee on improvement areas and on area where they are doing good.",
      "PMS feedbacks are clear indicators that explain “what is expected out of an employee’s performance” and “how his/her performance can affect entire integrated working of Organization”.",
    ],
  },
  {
    title: "Learning Management Framework (I-Learn, LMS)",
    content: [
      "Clear information about improvement areas and opportunities to learn specific skills make employees more confident about their career plans within the organization, which means finding their IKIGAI within the organization.",
    ],
  },
  {
    title: "Rewards & Recognition Framework",
    content: [
      "Organization has a wide and uniformly applicable R&R program effectively working.",
      "R&R ceremonies are organized where employees were rewarded with rewards to recognize their “out of the box and discretionary efforts” that they made in areas of Improvisation, Kaizen, Quality Circles, Lean etc.",
      "Program is constantly working and invite nomination from employees themselves, which enable them to express their own efforts in their own language to top most layers to management.",
      "Employee who earn R&R not just propagate their own careers as “Key Performers” but they also act as source of collective motivation in all employees.",
    ],
  },
];
export const DeepakData = [
  {
    content: [
      "Distribution of free Food Outside Civil Hospitals of Chandigarh",
      "Distribution of clothes to Old Age Home ",
      "Distribution of Winter Clothes to Casual Workers of organization",
      "Plantation of Trees in and around company premises",
      "Distribution of Free Winter Clothes (Jackets, Gloves, Caps) to Contract Workers of organization.",
    ],
  },
];

export const travelList = [
  { id: "publictransport", name: "Public Transport (Bus)" },
  { id: "train", name: "Train (if available)" },
  { id: "auto", name: "Auto/e-rikshaw" },
  { id: "twoWheeler", name: "Own 2 Wheeler" },
  { id: "uberBike", name: "Uber - Bike" },
];
export const othertravelList = [
  { id: "publictransport", name: "Public Transport (Bus)" },
  { id: "train", name: "Train (if available)" },
  { id: "auto", name: "Auto/e-rikshaw" },
  { id: "twoWheeler", name: "Own 2 Wheeler" },
  { id: "uberBike", name: "Uber - Bike" },
  { id: "fourWheeler", name: "Own Vehicle - 4 Wheeler" },
  { id: "cabCar", name: "Cab (Uber or alike)" },
];
export function calculateTravelDistance(location1, location2) {
  let distance = 0;
  switch (true) {
    case location1 === location2:
      distance = 0;
      break;
    case location1 === "Head Office" && location2 === "Bhagwanpura Plant":
    case location1 === "Bhagwanpura Plant" && location2 === "Head Office":
      distance = 30;
      break;
    case location1 === "Head Office" && location2 === "Essix Plant":
    case location1 === "Essix Plant" && location2 === "Head Office":
      distance = 20;
      break;
    case location1 === "Head Office" && location2 === "R&D Mohali":
    case location1 === "R&D Mohali" && location2 === "Head Office":
      distance = 22;
      break;
    case location1 === "Head Office" && location2 === "GBU":
    case location1 === "GBU" && location2 === "Head Office":
      distance = 25;
      break;
    case location1 === "R&D Mohali" && location2 === "Bhagwanpura Plant":
    case location1 === "Bhagwanpura Plant" && location2 === "R&D Mohali":
      distance = 35;
      break;
    case location1 === "R&D Mohali" && location2 === "Essix Plant":
    case location1 === "Essix Plant" && location2 === "R&D Mohali":
      distance = 30;
      break;
    case location1 === "R&D Mohali" && location2 === "GBU":
    case location1 === "GBU" && location2 === "R&D Mohali":
      distance = 35;
      break;
    case location1 === "Bhagwanpura Plant" && location2 === "GBU":
    case location1 === "GBU" && location2 === "Bhagwanpura Plant":
      distance = 10;
      break;
    case location1 === "Bhagwanpura Plant" && location2 === "Essix Plant":
    case location1 === "Essix Plant" && location2 === "Bhagwanpura Plant":
      distance = 8;
      break;
    case location1 === "GBU" && location2 === "Essix Plant":
    case location1 === "Essix Plant" && location2 === "GBU":
      distance = 8;
      break;
    default:
      distance = 1;
      break;
  }

  return distance;
}
export function getTransportScore(transport) {
  if (
    transport === "publictransport" ||
    transport === "train" ||
    transport === "cabCar" ||
    transport === "auto" ||
    transport === "uberBike"
  ) {
    return 4;
  } else if (transport === "twoWheeler") {
    return 5;
  } else if (transport === "fourWheeler") {
    return 9;
  } else {
    return 1; // return -1 if the input value doesn't match any of the specified cases
  }
}

export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export const removeUnderScore = (value) => {
  return value ? value.replace(/_/g, " ") : "";
};
export const  linkify =(text="") => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text?.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
}

export function getCurrency(currency) {
  switch (currency) {
    case "INR":
      return "₹ ";
    case "USD":
      return "$ ";
    case "EUR":
      return "€ ";
    default:
      return "";
  }
}
export const travelModeAir = [
  { id: "AIR", name: "Air" },
  { id: "TRAIN", name: "Train" },
  { id: "BUS", name: "Bus" },
  { id: "OWN_CAR", name: "Own Car" },
  { id: "COMPANY_CAR", name: "Company Car" },
];
export const otherTravelMode = [
  { id: "TRAIN", name: "Train" },
  { id: "BUS", name: "Bus" },
  { id: "OWN_CAR", name: "Own Car" },
  { id: "COMPANY_CAR", name: "Company Car" },
];
export const accomodationType = [
  { id: "HOTEL", name: "Hotel" },
  { id: "GUEST_HOUSE", name: "Guest House" },
  { id: "SELF_ARRANGEMENT", name: "Self Arrangement" },
  { id: "NA", name: "NA" },
];

export const dropDownValuesLoan = [
  { type: "MEDICAL_EXPENSE", experienceRequired: 1 },
  { type: "MARRAIGE", experienceRequired: 1 },
  { type: "EDUCATION", experienceRequired: 1 },
  { type: "VEHICLE", experienceRequired: 1 },
  { type: "HOME", experienceRequired: 1 },
];

export const entitlementAmout = (grade, book, cluster) => {
  if (book === "SELF_ARRANGEMENT") {
    switch (grade) {
      case "G1":
        return 600;
      case "G2":
        return 500;
      case "G3":
        return 500;
      case "G4":
        return 300;
      case "G5":
        return 300;
      case "G6":
        return 200;
      case "G7":
        return 200;
      case "G8":
        return 150;
      default:
        return 0;
    }
  } else if (book === "HOTEL") {
    if (cluster === "A") {
      switch (grade) {
        case "G1":
          return 6500;
        case "G2":
          return 5000;
        case "G3":
          return 4000;
        case "G4":
          return 3700;
        case "G5":
          return 3500;
        case "G6":
          return 3300;
        case "G7":
          return 2300;
        case "G8":
          return 1700;
        default:
          return 0;
      }
    } else if (cluster === "B") {
      switch (grade) {
        case "G1":
          return 5500;
        case "G2":
          return 4000;
        case "G3":
          return 3000;
        case "G4":
          return 2700;
        case "G5":
          return 2500;
        case "G6":
          return 2300;
        case "G7":
          return 1700;
        case "G8":
          return 1200;
        default:
          return 0;
      }
    } else if (cluster === "C") {
      switch (grade) {
        case "G1":
          return 5000;
        case "G2":
          return 3500;
        case "G3":
          return 2700;
        case "G4":
          return 2500;
        case "G5":
          return 2300;
        case "G6":
          return 2100;
        case "G7":
          return 1500;
        case "G8":
          return 1000;
        default:
          return 0;
      }
    }
  } else {
    switch (grade) {
      case "G1":
        return 0;
      case "G2":
        return 0;
      case "G3":
        return 0;
      case "G4":
        return 0;
      case "G5":
        return 0;
      case "G6":
        return 0;
      case "G7":
        return 0;
      case "G8":
        return 0;
      default:
        return 0;
    }
  }
};

export const entitlementForeign = (grade, book, country) => {
  if (book === "SELF_ARRANGEMENT") {
    if (country === "INDIA") {
      switch (grade) {
        case "G0":
          return 1300;
        case "G1":
          return 1100;
        case "G2":
          return 800;
        case "G3":
          return 600;
        case "G4":
          return 540;
        case "G5":
          return 500;
        case "G6":
          return 460;
        case "G7":
          return 340;
        case "G8":
          return 240;
        default:
          return 0;
      }
    } else {
      switch (grade) {
        case "G0":
          return 32;
        case "G1":
          return 32;
        case "G2":
          return 32;
        case "G3":
          return 28;
        case "G4":
          return 28;
        case "G5":
          return 28;
        case "G6":
          return 28;
        case "G7":
          return 28;
        case "G8":
          return 28;
        default:
          return 0;
      }
    }
  } else {
    if (country === "INDIA") {
      switch (grade) {
        case "G0":
          return 6500;
        case "G1":
          return 5500;
        case "G2":
          return 4000;
        case "G3":
          return 3000;
        case "G4":
          return 2700;
        case "G5":
          return 2500;
        case "G6":
          return 2300;
        case "G7":
          return 1700;
        case "G8":
          return 1200;
        default:
          return 0;
      }
    } else {
      switch (grade) {
        case "G0":
          return 160;
        case "G1":
          return 160;
        case "G2":
          return 160;
        case "G3":
          return 140;
        case "G4":
          return 140;
        case "G5":
          return 140;
        case "G6":
          return 140;
        case "G7":
          return 140;
        case "G8":
          return 140;
        default:
          return 0;
      }
    }
  }
};

export const travelListExpense = [
  { id: "flight", name: "Flight" },
  { id: "PUBLIC_TRANSPORT", name: "Public Transport (Bus)" },
  { id: "TRAIN", name: "Train (if available)" },
  { id: "AUTO", name: "Auto/e-rikshaw" },
  { id: "TWO_WHEELER", name: "Own 2 Wheeler" },
  { id: "UBER_BIKE", name: "Uber - Bike" },
  { id: "COMPANY_VEHICLE", name: "Company Vehicle" },
  { id: "OWN_CAR", name: "Personal Car" },
];

export const travelListForeignExpense = [
  { id: "flight", name: "Flight" },
  { id: "PUBLIC_TRANSPORT", name: "Public Transport (Bus)" },
  { id: "TRAIN", name: "Train (if available)" },
  { id: "AUTO", name: "Auto/e-rikshaw" },
  { id: "UBER_BIKE", name: "Uber - Bike" },
  { id: "COMPANY_VEHICLE", name: "Company Vehicle" },
];

export const DAAllotAmout = (grade, book) => {
  if (book === "SELF_ARRANGEMENT") {
    switch (grade) {
      case "G0":
        return 500;
      case "G1":
        return 400;
      case "G2":
        return 300;
      case "G3":
        return 300;
      case "G4":
        return 300;
      case "G5":
        return 300;
      case "G6":
        return 200;
      case "G7":
        return 200;
      case "G8":
        return 100;
      default:
        return 0;
    }
  } else {
    switch (grade) {
      case "G0":
        return 1200;
      case "G1":
        return 1000;
      case "G2":
        return 900;
      case "G3":
        return 800;
      case "G4":
        return 700;
      case "G5":
        return 600;
      case "G6":
        return 500;
      case "G7":
        return 300;
      case "G8":
        return 250;
      default:
        return 0;
    }
  }
};
export const DAAllotForeignAmout = (grade, currency, cp) => {
  if (cp) {
    return 50;
  }
  if (currency === "EUR") {
    switch (grade) {
      case "G0":
        return 70;
      case "G1":
        return 70;
      case "G2":
        return 70;
      case "G3":
        return 60;
      case "G4":
        return 60;
      case "G5":
        return 60;
      case "G6":
        return 60;
      case "G7":
        return 60;
      case "G8":
        return 60;
      default:
        return 0;
    }
  } else if (currency === "USD") {
    switch (grade) {
      case "G0":
        return 75;
      case "G1":
        return 75;
      case "G2":
        return 75;
      case "G3":
        return 65;
      case "G4":
        return 65;
      case "G5":
        return 65;
      case "G6":
        return 65;
      case "G7":
        return 65;
      case "G8":
        return 65;
      default:
        return 0;
    }
  } else {
    switch (grade) {
      case "G0":
        return 1200;
      case "G1":
        return 1000;
      case "G2":
        return 900;
      case "G3":
        return 800;
      case "G4":
        return 700;
      case "G5":
        return 600;
      case "G6":
        return 500;
      case "G7":
        return 300;
      case "G8":
        return 250;
      default:
        return 0;
    }
  }
};
export const IEForeignAllotAmout = (grade, currency) => {
  if (currency === "INR") {
    switch (grade) {
      case "G0":
        return 500;
      case "G1":
        return 300;
      case "G2":
        return 220;
      case "G3":
        return 200;
      case "G4":
        return 180;
      case "G5":
        return 160;
      case "G6":
        return 160;
      case "G7":
        return 100;
      case "G8":
        return 50;
      default:
        return 0;
    }
  } else {
    switch (grade) {
      case "G0":
        return 15;
      case "G1":
        return 15;
      case "G2":
        return 15;
      case "G3":
        return 10;
      case "G4":
        return 10;
      case "G5":
        return 10;
      case "G6":
        return 10;
      case "G7":
        return 10;
      case "G8":
        return 10;
      default:
        return 0;
    }
  }
};

export const IEAllotAmout = (grade) => {
  switch (grade) {
    case "G0":
      return 500;
    case "G1":
      return 300;
    case "G2":
      return 220;
    case "G3":
      return 220;
    case "G4":
      return 180;
    case "G5":
      return 160;
    case "G6":
      return 100;
    case "G7":
      return 100;
    case "G8":
      return 50;
    default:
      return 0;
  }
};
export const getFixedValue = (val) => {
  const num = Number(val);
  if (num === 0) {
    return 0;
  } else if (num === 1) {
    return 170;
  } else if (num === 2) {
    return 340;
  }
};
            
export const number_Keys = [
  "notice_period",
  "served_for",
  "notice_leave_availed",
  "shortfall_notice_period",
  "payroll_one_paid_days",
  "payroll_one_value",
  "payroll_two_paid_days",
  "payroll_two_value",
  "payroll_three_paid_days",
  "payroll_three_value",
  "statutory_bonus",
  "gratuity",
  "declared_pli",
  "un_declared_pli",
  "professional_upgradation",
  "helper_allowance",
  "food_coupon",
  "gift_coupon_bonus",
  "lta",
  "superannuation",
  "incentive",
  "car_maintenance",
  "fuel",
  "vpf",
  "el_balance",
  "el_balance_value",
  "el_currnet_service_year",
  "el_currnet_service_year_value",
  "fel",
  "fel_value",
  "rbl",
  "rbl_value",
  "nfh",
  "pf",
  "esi",
  "labour_welfare_fund",
  "mobile_device_recovery",
  "car_maintenance_recovery",
  "notice_period_recovery",
  "bgv",
  "relocation_recovery",
  "transportation_deduction",
  "safety_gadget_recovery",
  "it_asset_recovery",
  "canteen_recovery",
  "imprest_recovery",
  "petro_card_recovery",
  "smart_card_recovery",
  "loan_final_recovery",
  "adv_salary_recovery",
  "i_card_recovery",
  "other_recovery",
  "tds",
  "professional_tax",
  "car_status",
  "total_recovery",
  "un_declared_pli_uphold",
  "gratuity_uphold",
  "statutory_bonus_uphold",
  "el_balance_uphold",
  "el_currnet_service_year_uphold",
  "fel_uphold",
  "rbl_uphold",
  "superannuation_uphold",
];

export function getNullPaths(data) {
  const nullPathObjects = [];
    const uniquePathObjects = [];
    const uniquePaths = new Set();

  data.forEach(item => {
    const path = item.path;

    if (path === "null") {
        nullPathObjects.push(item);
    } else if (path && path !== "null" && !uniquePaths.has(path)) {
        uniquePaths.add(path);
        uniquePathObjects.push(item);
    }
});

return { nullPathObjects, uniquePathObjects };
}
export const isDateInFiscalYear = (date) => {
  const month = date.getMonth() + 1;
  return (
    (month === 1 && date.getDate() >= 7 && date.getDate() <= 31) ||
    (month > 1 && month < 3) ||
    (month === 3 && date.getDate() <= 25)
  );
};
export const calculateFinancialYear = (date) => {
  const currentMonth = date.getMonth() + 1; // Adding 1 to get month number starting from 1

  let fyStartYear, fyEndYear;

  if (currentMonth >= 4) {
    fyStartYear = date.getFullYear();
    fyEndYear = date.getFullYear() + 1;
  } else {
    fyStartYear = date.getFullYear() - 1;
    fyEndYear = date.getFullYear();
  }

  return `${fyStartYear}-${fyEndYear}`;
};
// "INTERNAL" "EXTERNAL" => nature
// IN_PLACE NOT_IN_PLACE =>succession

export const getSajStatus = (succession, nature) => {
  if (succession === "IN_PLACE" && nature === "INTERNAL") {
    return "REPLACEMENT_INTERNAL";
  } else if (succession === "IN_PLACE" && nature === "EXTERNAL") {
    return "REPLACEMENT_EXTERNAL";
  } else if (succession === "REJECTED" && nature === "REJECTED") {
    return "REJECTED";
  } else if (succession === "NOT_IN_PLACE") {
    return "NOT_IN_PLACE";
  } else {
    return "PENDING";
  }
};
export const  convertDateToMonthAbbreviation = (dateString)=> {
  const date = moment(dateString, "DD/MM/YYYY");
  const formattedDate = date.format("DD/MMM/YYYY");
  
  return formattedDate;
}

export const shiftdays= {
  week_day: "",
  start_time: null,
  end_time: null,
  total_hours: null,
  is_week_off: false,
  is_occasional_working: false,
  occasional_working_days: [],
}
export const getWorkingDays = {
  1: "First",
  2: "Second",
  3: "Third",
  4: "Fouth",
  5:"Fifth"
};

export const getBackgroundColor = ((value) => {
  if(value < 0) return "#E92828"
  if(value >= 0 && value < 70.99) return "#F4881B"
  if(value > 71 && value < 100) return "#29CB97"
  return "#A613DC";
});
export const getBackgroundColorHq = ((value) => {
  if(value == 0) return "#B8C5D3"
  if(value > 0 & value < 50) return "#E92828"
  if(value >= 50 && value < 100) return "#F4881B"
  if(value == 100) return "#29CB97"
  return "#A613DC";
});
export const getEmpStatusColor = (value) => {
  const statusColorMap = {
    active: "#29CB97",
    inactive: "#E92828",
    terminated: "#0CD5C8",
    resigned: "#2005A2",
    absconded: "#7700FF",
    expired: "#2896E9",
    retired: "#919BB0",
  };
  return statusColorMap[value?.toLowerCase()] || "#A613DC";
};

export const myValues = ["2021-2022", "2022-2023", "2024-2025", "2023-2024"];

export const updateLabels =(data=[]) => {
  return data?.map(item => {
    return {
      ...item,
      label: `FY ${item?.value}`
    };
  });
}

export const quarters = {
  Q1: [
    { name: "July", value: 7 },
    { name: "August", value: 8 },
    { name: "September", value: 9 },
  ],
  Q2: [
    { name: "October", value: 10 },
    { name: "November", value: 11 },
    { name: "December", value: 12 },
  ],
  Q3: [
    { name: "January", value: 1 },
    { name: "February", value: 2 },
    { name: "March", value: 3 },
  ],
  Q4: [
    { name: "April", value: 4 },
    { name: "May", value: 5 },
    { name: "June", value: 6 },
  ],
};

export const quartersFY = {
  Q2: [
    { name: "July", value: 7 },
    { name: "August", value: 8 },
    { name: "September", value: 9 },
  ],
  Q3: [
    { name: "October", value: 10 },
    { name: "November", value: 11 },
    { name: "December", value: 12 },
  ],
  Q4: [
    { name: "January", value: 1 },
    { name: "February", value: 2 },
    { name: "March", value: 3 },
  ],
  Q1: [
    { name: "April", value: 4 },
    { name: "May", value: 5 },
    { name: "June", value: 6 },
  ],
};

  export const getMonthName = (monthNumber) => {
  for (const quarter in quartersFY) {
    const found = quartersFY[quarter].find((m) => m.value === Number(monthNumber));
    if (found) return found.name;
  }
  return "";
};

export const allQuarters = ["Q1", "Q2", "Q3", "Q4"];

export const financialYears = ["2026-2027", "2025-2026", "2024-2025","2023-2024","2022-2023", "2021-2022"] ;